import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Button,
  Col,
  OverlayTrigger,
  Row,
  Table,
  Tooltip,
  Modal,
} from "@themesberg/react-bootstrap";
import { motion } from "framer-motion/dist/framer-motion";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import { transactionDriverHeaders } from "./constants";
import AddEditModal from "./components/AddEditModal";
import useTransactionsDriver from "./hooks/useTransactionsDriver";
import NotificationIconContainer from "../../../components/NotificationIcon/NotificationIconContainer";
import Preloader from "../../../components/Preloader";
import PaginationComponent from "../../../components/Pagination";
import Toggle from "./components/Toggle";
import { ActionButton } from "../../../components/TransactionsList/style";
import { Edit } from "@mui/icons-material";
import { TruncatedText } from "../../../components/TruncatedText";
import useCheckPermission from "../../../utils/checkPermission";
import { DeleteConfirmationModal } from "../../../components/ConfirmationModal"
import useTableCustom from "../../../components/CusotmFilter"

import { AddButtonStyled, ButtonContainer, HeaderSection, ResponsiveTitle } from "../TransactionsBanking/style";
import TableErrorMessage from "../../../components/TableErrorMessage"
import ActionMenu from "./ActionMenu";


export default function TransactionsDriver() {
  const {
    page,
    limit,
    setPage,
    setLimit,
    loading,
    handleCreateEdit,
    handleToggleStatus,
    type,
    data,
    setShow,
    show,
    createUpdate,
    dispatch,
    agents,
    validation,
    setValidation,
    totalPages,
    handleDelete,
    deleteConfirmation,
    setDeleteConfirmation,
    onhandleDelete,
    totalCount
  } = useTransactionsDriver();

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingStatusChange, setPendingStatusChange] = useState(null);
  const { isHidden } = useCheckPermission();
  let headers = transactionDriverHeaders;



  const handleToggleChange = (transactionAgentId, newStatus, agentName) => {
    setPendingStatusChange({
      transactionAgentId,
      newStatus,
      agentName,
    });
    setShowConfirmModal(true);
  };

  const confirmStatusChange = () => {
    if (pendingStatusChange) {
      handleToggleStatus(
        pendingStatusChange.transactionAgentId,
        pendingStatusChange.newStatus
      );
    }
    setShowConfirmModal(false);
    setPendingStatusChange(null);
  };

  const cancelStatusChange = () => {
    setShowConfirmModal(false);
    setPendingStatusChange(null);
  };

  const isShowActionColumnCG = !isHidden({ module: { key: "TransactionsDriver", value: "U" } }) || !isHidden({ module: { key: "TransactionsDriver", value: "D" } })
  const isToggleColumn = !isHidden({ module: { key: "TransactionsDriver", value: "T" } })
  // const dynamicTableHeaders = useMemo(() => {
  //   const headerscol = [...headers.filter(col => col.value !== 'action')];
  //   if (isToggleColumn) {
  //     headerscol.push({
  //       label: 'Status',
  //       value: 'status',
  //       Header: 'Status',
  //       accessorKey: 'status',
  //       required: true,
  //       inputType: 'text',
  //     })
  //   }
  //     if (isShowActionColumnCG) {
  //       headerscol.push({
  //         accessorKey: 'action',
  //         Header: 'Actions',
  //         value: 'action',
  //         label: 'Actions',
  //       });
  //     }


  //   return headerscol;
  // }, [isShowActionColumnCG , isToggleColumn]);


  const dynamicTableHeaders = useMemo(() => {
    let headersCol = [...headers];

    if (!isToggleColumn) {
      headersCol = headersCol.filter(col => col.value !== 'status');
    }

    if (!isShowActionColumnCG) {
      headersCol = headersCol.filter(col => col.value !== 'action');
    }

    return headersCol;
  }, [headers, isToggleColumn, isShowActionColumnCG]);



  const {
    visibleColumns,
    pageData,
    customColSetting,
    noDataFound,
  } = useTableCustom(
    agents,
    dynamicTableHeaders, // already permission-filtered
    false,
    () => { },
    null,
    null,
    false,
    "",
    true,
    "TRANSACTION_DRIVERS"
  );
  const headerRef = useRef(null);
  const filterRef = useRef(null);
  const paginationRef = useRef(null);
  const [tableMaxHeight, setTableMaxHeight] = useState("");
  console.log(dynamicTableHeaders, visibleColumns, "dynamic headerrrrrrrrrrrrrrrrrrrrrrrrrr")

  useEffect(() => {
    const updateMaxHeight = () => {
      const headerHeight = headerRef.current?.offsetHeight || 0;
      const filterHeight = filterRef.current?.offsetHeight || 0;
      const paginationHeight = paginationRef?.current?.offsetHeight || 0;

      const responsiveTable = document.querySelector('.table-responsive');
      const totalHeight = headerHeight + filterHeight + paginationHeight;
      const availableHeight = window.innerHeight - totalHeight - 110;

      if (window.innerWidth < 1000) {
        // For smaller screens: reset to full height
        if (responsiveTable) {

          responsiveTable.style.maxHeight = '100%';
          responsiveTable.style.overflowY = 'unset';
        }
        setTableMaxHeight('100%');
        return;
      }
      else if (responsiveTable) {

        responsiveTable.style.maxHeight = `${availableHeight}px`;
        responsiveTable.style.overflowY = 'auto'; // ensure scrolling
        setTableMaxHeight(`${availableHeight}px`);
      }


    };

    updateMaxHeight();
    window.addEventListener("resize", updateMaxHeight);
    return () => window.removeEventListener("resize", updateMaxHeight);
  }, [agents]);
  return (
    <>
      <HeaderSection className="section-header-wrap" ref={headerRef}>
        <Row className="justify-content-between align-items-center g-3">
          <Col xs={12} xl={6}>
            <ResponsiveTitle className="title-text">
              Transactions Driver
            </ResponsiveTitle>
          </Col>


          <Col xs={12} xl={6}>
            <ButtonContainer
              className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center justify-content-md-end gap-2"
            >
              <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                className="flex-grow-1 flex-md-grow-0"
                hidden={isHidden({
                  module: { key: "TransactionsDriver", value: "C" },
                })}
              >
                <AddButtonStyled
                  variant="primary"
                  className="w-100 w-md-auto"
                  onClick={() => handleCreateEdit("Create")}
                >
                  <AddCircleOutlineRoundedIcon />
                  <span>Add Driver Details</span>
                </AddButtonStyled>
              </motion.div>

              <div className="custom-col-setting-width">
                {customColSetting}
              </div>
              <div>
                <NotificationIconContainer />
              </div>
            </ButtonContainer>
          </Col>

        </Row>
      </HeaderSection>
      {loading ? (
        <Preloader />
      ) : (


        visibleColumns?.length > 0 ? <>
          <div className="TableBg mt-4">
            <Table striped responsive hover size="sm" className="text-center">
              <thead className="thead-light">
                <tr>
                  {visibleColumns.map((h, index) => (
                    <th key={`${h.value}-${index}`}>{h.label}</th>
                  ))}
                </tr>
              </thead>

              <tbody id={loading ? "cover-spin" : ""}>
                {!loading && agents?.length > 0 &&
                  agents.map((row, indx) => (
                    <tr key={row.transactionAgentId}>
                      {visibleColumns.map((col, cIdx) => {
                        const key = col.accessorKey;
                        const value = row[key];

                        switch (key) {
                          case "agentName":
                            return (
                              <td key={cIdx}>
                                <span
                                  style={{ width: "200px", cursor: "default" }}
                                  className="d-inline-block text-truncate"
                                >
                                  {value || "NA"}
                                </span>
                              </td>
                            );

                          case "agentNumber":
                            return (
                              <td key={cIdx} style={{ maxWidth: "150px" }}>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id={`tooltip-agent-number-${row.transactionAgentId}`}>
                                      {value || "NA"}
                                    </Tooltip>
                                  }
                                >
                                  <span
                                    style={{
                                      display: "inline-block",
                                      width: "100%",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {value || "NA"}
                                  </span>
                                </OverlayTrigger>
                              </td>
                            );

                          case "agentEmail":
                            return (
                              <td key={cIdx} style={{ wordBreak: "break-word", maxWidth: "200px" }}>
                                {value || "NA"}
                              </td>
                            );

                          case "description":
                            return (
                              <td key={cIdx}>
                                <TruncatedText text={value || "NA"} />
                              </td>
                            );

                          case "status":
                            return (
                              <td
                                key={cIdx}
                                hidden={isHidden({ module: { key: "TransactionsDriver", value: "T" } })}
                              >
                                <Toggle
                                  checked={value}
                                  onChange={(e) =>
                                    handleToggleChange(
                                      row.transactionAgentId,
                                      e.target.checked,
                                      row.agentName
                                    )
                                  }
                                  align="left"
                                  size="small"
                                />
                              </td>
                            );

                          case "action":
                            return (
                              // <td key={cIdx}>
                              //   {/* Edit */}
                              //   {!isHidden({ module: { key: "TransactionsDriver", value: "U" } }) && (
                              //     <OverlayTrigger
                              //       placement="top"
                              //       overlay={
                              //         <Tooltip id={`edit-tooltip-${row.transactionAgentId}`}>
                              //           Edit
                              //         </Tooltip>
                              //       }
                              //     >
                              //       <ActionButton
                              //         aria-label="edit"
                              //         onClick={() => handleCreateEdit("Edit", row)}
                              //       >
                              //         <i className="fas fa-edit" />
                              //       </ActionButton>
                              //     </OverlayTrigger>
                              //   )}

                              //   {/* Delete */}
                              //   {!isHidden({ module: { key: "TransactionsDriver", value: "D" } }) && (
                              //     <OverlayTrigger
                              //       placement="top"
                              //       overlay={
                              //         <Tooltip id={`delete-tooltip-${row.transactionAgentId}`}>
                              //           Delete
                              //         </Tooltip>
                              //       }
                              //     >
                              //       <ActionButton
                              //         aria-label="delete"
                              //         onClick={() => handleDelete(row)}
                              //       >
                              //         <i className="fas fa-trash-alt" />
                              //       </ActionButton>
                              //     </OverlayTrigger>
                              //   )}
                              // </td>
                              <td>
                                <ActionMenu isHidden={isHidden} handleCreateEdit={() => handleCreateEdit("Edit", row)} handleDelete={() => handleDelete(row)} />
                              </td>

                            );

                          default:
                            return <td key={cIdx}>{value ?? "NA"}</td>;
                        }
                      })}
                    </tr>
                  ))}

                {agents?.length === 0 && !loading && (
                  <tr>
                    <td colSpan={visibleColumns.length} className="text-danger text-center">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>

            </Table>
          </div>

          {agents?.count !== 0 && !loading && (
            <PaginationComponent
              page={agents?.count < page ? setPage(1) : page}
              totalPages={totalPages}
              setPage={setPage}
              limit={limit}
              setLimit={setLimit}
              showTotalCount={true}
              totalCount={totalCount}
              countText="Total Transactions Driver : "
            />
          )}
        </> : <TableErrorMessage />
      )}



      <AddEditModal
        type={type}
        data={data}
        show={show}
        setShow={setShow}
        createUpdate={createUpdate}
        dispatch={dispatch}
        agents={agents}
        validation={validation}
        setValidation={setValidation}
      />

      {deleteConfirmation?.open ? <DeleteConfirmationModal
        handleDeleteYes={onhandleDelete}
        setDeleteModalShow={() => setDeleteConfirmation({
          open: false,
          title: '',
        })}
        deleteModalShow={true}
        name={`${deleteConfirmation?.name} Transaction Driver`}
      /> : ""}

      <Modal
        show={showConfirmModal}
        onHide={cancelStatusChange}
        centered
        backdrop="static"
        style={{
          backdropFilter: "blur(15px)",
          WebkitBackdropFilter: "blur(15px)",
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Status Change</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {pendingStatusChange && (
            <div>
              <p>
                Are you sure you want to{" "}
                <strong>
                  {pendingStatusChange.newStatus ? "activate" : "deactivate"}
                </strong>{" "}
                the driver <strong>"{pendingStatusChange.agentName}"</strong>?
              </p>
              <div className="d-flex align-items-center mt-3">
                <strong>Status will change to: </strong>
                <span
                  className={`ms-2 badge ${pendingStatusChange.newStatus ? "bg-success" : "bg-danger"
                    }`}
                >
                  {pendingStatusChange.newStatus ? "Active" : "Inactive"}
                </span>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant={pendingStatusChange?.newStatus ? "success" : "danger"}
            onClick={confirmStatusChange}
          >
            Confirm{" "}
            {pendingStatusChange?.newStatus ? "Activation" : "Deactivation"}
          </Button>
          <Button variant="secondary" onClick={cancelStatusChange}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
